import { createCircle } from './circle/create';
import { resizeCircle } from './circle/edit';
import { bendLineInProgress, createCurve } from './curve/create';
import { bendLine, straightenLine } from './curve/edit';
import { deleteSelectedGeometry } from './delete-selected-geometry';
import { deleteFace } from './face/delete';
import { flipFace } from './face/flip-face';
import { gridFunctions } from './features/generate-grid';
import { lineSegmentFunctions } from './features/generate-line-segments';
import { importFunctions } from './features/import-geometry';
import { interpolatePointHeightsUtils } from './features/interpolate-point-heights-utils';
import { offsetUtils } from './features/offset-utils';
import { pointHeightFunctions } from './features/set-point-heights';
import { triangulateFunctions } from './features/triangulate';
import {
  abortActionInProgress,
  abortActionInProgressAffirmative,
  abortTool,
  applyActionInProgress,
  createActions,
  deselectAll,
  initActionInProgress,
  quickSelectLineOrPolygon,
  redo,
  saveTool,
  selectAll,
  selectLineOrPolygon,
  showFunctions,
  showOptions,
  tools,
  undo,
} from './general';
import { createLine } from './line/create';
import { deleteLine } from './line/delete';
import { flipBreakline } from './line/flip-break-line';
import { createPoint } from './point/create';
import { createFromDialogFunctions } from './point/create-from-dialog';
import { deletePoint } from './point/delete';
import { movePoint } from './point/move';
import { startPolylineSelection } from './start-line-selection';
import { createTextAction } from './text/create';

function buildCommands() {
  return {
    abortActionInProgress,
    abortActionInProgressAffirmative,
    abortTool,
    applyActionInProgress,
    createActions,
    deselectAll,
    initActionInProgress,
    quickSelectLineOrPolygon,
    redo,
    saveTool,
    selectAll,
    selectLineOrPolygon,
    showFunctions,
    showOptions,
    tools,
    undo,
    ...interpolatePointHeightsUtils,
    createTextAction,
    createPoint,
    deletePoint,
    movePoint,
    createLine,
    createCurve,
    bendLineInProgress,
    createCircle,
    resizeCircle,
    bendLine,
    straightenLine,
    deleteLine,
    deleteFace,
    flipFace,
    flipBreakline,
    ...pointHeightFunctions,
    ...triangulateFunctions,
    ...gridFunctions,
    ...lineSegmentFunctions,
    ...offsetUtils,
    ...importFunctions,
    ...createFromDialogFunctions,
    startPolylineSelection,
    deleteSelectedGeometry,
  };
}

// Lazy proxy to break: feature files → point/pick → asset-manager → design-tool → commands/index → feature files.
// The imports above are resolved at module load time, but the spread of their exports is deferred
// to the first property access, by which point all modules are fully initialized.
type Commands = ReturnType<typeof buildCommands>;
let _cache: Commands | undefined;
export const designToolCommands = new Proxy({} as Commands, {
  get(_, prop: string) {
    _cache ??= buildCommands();
    return _cache[prop as keyof Commands];
  },
});
